import { render, staticRenderFns } from "./ComponentRoot.vue?vue&type=template&id=b60db418"
import script from "./ComponentRoot.vue?vue&type=script&setup=true&lang=js"
export * from "./ComponentRoot.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports